import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { MatPaginator, MatDialog, PageEvent, Sort, MatTabChangeEvent } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { ExcelHelperService } from 'src/app/Services/Utilities/excel-helper.service';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';

@Component({
  selector: 'app-dashboard-borad',
  templateUrl: './dashboard-borad.component.html',
  styleUrls: ['./dashboard-borad.component.scss']
})
export class DashboardBoradComponent implements OnInit {

  vanguardList = [];
  trailblazerList = [];

  filelist = [];
  sortedfilelist = [];
  length = 0;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 15, 20];
  pageIndex = 0;
  offset = this.pageSize * this.pageIndex;
  searchbox = '';
  searchValue = '';
  sortedu = {
    active: 'booth',
    direction: 'desc'
  };
  loading = true;
  selectedIndex = 0;
  parentSelectedIndex = 0;
  parent2SelectedIndex = 0;


  role: string[];

  types = [
    'Health & Well-being',
    'Energy & Environment protection',
    'Education & Enhancing Communities',
    'Responsible Industry & Partnership'
  ]
  filter = 'Health & Well-being'

  open=false;

  @ViewChild('topPaginator', { read: MatPaginator, static: false }) topPaginator: MatPaginator;
  @ViewChild('bottomPaginator', { read: MatPaginator, static: false }) bottomPaginator: MatPaginator;

  constructor(
    private userinfoSrv: UserInfoService,
    private firestore: AngularFirestore,
    private spinner: NgxSpinnerService,
    private dialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private toaster: ToastrService,
    private router: Router,
    private excelHelper: ExcelHelperService
  ) { 
    this.userinfoSrv.currentRole.subscribe(role => this.role = role);
    this.getFile();

    this.firestore.collection('Setting').doc('Deadline').get().forEach(e=>{
      if(e.exists){
        this.open = e.data().value;
      }
    })


  }
  ngOnInit(): void {
  }

  email=''
  getFile(){
    this.spinner.show();

    this.firestore.collection('Exhib', ref=>ref.where('Status', 'in', [ 'Submission in process', 'Assigned', 'Completed'])).get().forEach(e => {
      e.forEach(file => {
        const data : any= {
          ...file.data(),
          id: file.id,
          calculatedMark: file.data().calculatedMark,
          totalMark: 0,
          averageMark: 0,
          marks: file.data().marks,
          CreatedDate: new Date(file.data().CreatedDate.toDate()),
        };

        const regex = /booth number is (\d+)/i;
        if (data.adminRemark) {
          const match = data.adminRemark.match(regex);
          if (match && match.length > 1) {
            data.booth = match[1] || ''
          } else {
            data.booth = ''
          }
        }

        if(!data.finalMark){
          if (data.calculatedMark) {
            for (const mark of Object.values(data.calculatedMark)) {
              data.totalMark += parseFloat(this.getMark(mark));
            }
            data.averageMark = data.totalMark / Object.values(data.calculatedMark).length;
          }
        }else{
          data.averageMark = parseFloat(data.finalMark);
        }

        if(data.modeInfo?data.modeInfo.category.includes('Trailblazer'): false){
          this.trailblazerList.push(data)
        }else if(data.modeInfo?data.modeInfo.category.includes('Vanguard'): false){
          this.vanguardList.push(data)
        }

        this.sortedfilelist = this.filterAgain();
        this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
        this.loading = false;
        this.length = this.filterAgain().length;
      })
      this.spinner.hide();
      this.loading = false;
    });
  }

  numberOfApplication = 0;
  totalMark = 0;
  avgMark = 0;
  goldThreshold = 0;
  silverThreshold = 0;
  bronzeThreshold = 0;
  vanguard1 = [];
  vanguard2 = [];
  vanguard3 = [];
  category1 = [];
  category2 = [];
  category3 = [];
  category4 = [];

  marked1Application = []
  marked2Application = []
  filterAgain(){
    this.numberOfApplication = 0;
    this.totalMark = 0;
    this.avgMark = 0;
    this.goldThreshold = 0;
    this.silverThreshold = 0;
    this.bronzeThreshold = 0;
    this.vanguard1 = [];
    this.vanguard2 = [];
    this.vanguard3 = [];
    this.category1 = [];
    this.category2 = [];
    this.category3 = [];
    this.category4 = [];

    if(this.parentSelectedIndex === 0){
      this.filelist = this.vanguardList.slice();
      this.marked1Application = this.vanguardList.slice();
    }else{
      this.filelist = this.trailblazerList.slice();
      this.marked2Application = this.trailblazerList.slice();
    }
    this.filelist = this.filelist.sort((a,b)=> this.compare(a.averageMark, b.averageMark, false))

    let list1 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[0])
    let list2 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[1])
    let list3 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[2])
    let list4 = this.filelist.filter(e=>e.techFormGroup.Category === this.types[3])



    if(list1.length > 0){
      let temp = null;
      for (const element of list1) {
        if(temp === element.averageMark)
          this.category1.push(element)
        else if(temp == null)
          this.category1.push(element)
        else
          break;
        temp = element.averageMark
      }
    }
    if(list2.length > 0){
      let temp = null;
      for (const element of list2) {
        if(temp === element.averageMark)
          this.category2.push(element)
        else if(temp == null)
          this.category2.push(element)
        else
          break;
        temp = element.averageMark
      }
    }
    if(list3.length > 0){
      let temp = null;
      for (const element of list3) {
        if(temp === element.averageMark)
          this.category3.push(element)
        else if(temp == null)
          this.category3.push(element)
        else
          break;
        temp = element.averageMark
      }
    }
    if(list4.length > 0){
      let temp = null;
      for (const element of list4) {
        if(temp === element.averageMark)
          this.category4.push(element)
        else if(temp == null)
          this.category4.push(element)
        else
          break;
        temp = element.averageMark
      }
    }

    let highestMark = 0;
    let highestIndex = 0;

    if(this.filelist.length > 0){

      for (const element of this.filelist) {
        if(element.averageMark === highestMark){
          highestMark = element.averageMark;
          if(highestIndex === 0)
            this.vanguard1.push(element)
          else if(highestIndex === 1)
            this.vanguard2.push(element)
          else if(highestIndex === 2)
            this.vanguard3.push(element)
          else
            break;
        }else{
          highestMark = element.averageMark;
          if(this.vanguard1.length >= 1)
            highestIndex++;

          if(highestIndex === 0)
            this.vanguard1.push(element)
          else if(highestIndex === 1)
            this.vanguard2.push(element)
          else if(highestIndex === 2)
            this.vanguard3.push(element)
          else
            break;
        }
      }
    }


    let exl = this.filelist.filter(e=>e.techFormGroup.Category === this.filter && e.averageMark > 0);
    let totalMark = exl.reduce((a,b)=> a + b.averageMark, 0);
    this.numberOfApplication =  exl.length;
    this.totalMark = totalMark;

    if(totalMark > 0){
      this.avgMark = (totalMark/exl.length);
      let goldThreshold = Math.floor((exl.length * 0.3))
      let silverThreshold = Math.floor((exl.length * 0.4))
      let bronzeThreshold = exl.length - goldThreshold - silverThreshold;

      this.goldThreshold = goldThreshold;
      this.silverThreshold = silverThreshold;
      this.bronzeThreshold = bronzeThreshold;
      for (let index = 0; index < exl.length; index++) {
        const element = exl[index];

        if(index+1 <= goldThreshold){
          element.result = 'Gold'
        }else if(index+1 <= goldThreshold + silverThreshold){
          element.result = 'Silver'
        }else{
          element.result = 'Bronze'
        }
      }
     
    }

    let dup = this.filelist.filter(e=>e.techFormGroup.Category === this.filter).slice();
    return dup;
  }

  getMark(marks) {
    return marks.reduce((a, b) => a + (b?parseFloat(b): 0), 0).toFixed(2)
  }

  getSMark(email, file) {
    let str = ''
    str = file.calculatedMark ? Object.keys(file.calculatedMark).includes(email) ? this.getMark(file.calculatedMark[email]) : '?' : '?';
    return str;
  }

  paginator(pageEvent: PageEvent) {
    this.pageSize = pageEvent.pageSize;
    this.pageIndex = pageEvent.pageIndex;
    this.offset = this.pageSize * this.pageIndex;
    if (this.topPaginator.pageIndex < this.pageIndex) {
      this.topPaginator.nextPage();
    } else if (this.topPaginator.pageIndex > this.pageIndex) {
      this.topPaginator.previousPage();
    }
    if (this.bottomPaginator.pageIndex < this.pageIndex) {
      this.bottomPaginator.nextPage();
    } else if (this.bottomPaginator.pageIndex > this.pageIndex) {
      this.bottomPaginator.previousPage();
    }
    
    this.sortedfilelist = this.filterAgain();
    this.sortFile();
    this.limitFile();
  }

  limitFile() {
    this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
  }

  sortData(sort: Sort) {
    this.sortedu = sort;
    this.sortedfilelist = this.filterAgain();
   
    if (!sort.active || sort.direction === '' ) {
      this.sortedfilelist = this.filterAgain();
      this.limitFile();
      return;
    }

    this.sortedfilelist = this.sortedfilelist.sort((a, b) => {
      const isAsc = this.sortedu.direction === 'asc';
      switch (this.sortedu.active) {
        case 'title': return this.compare(a.introFormGroup.ProjectTitle, b.introFormGroup.ProjectTitle, isAsc);
        case 'name': return this.compare(a.introFormGroup.Applicant, b.introFormGroup.Applicant, isAsc);
        case 'description': return this.compare(a.introFormGroup.School, b.introFormGroup.School, isAsc);
        case 'result': return this.compare(a.result, b.result, isAsc);
        case 'booth': return this.compare(isNaN(parseFloat(a.booth))? 0:parseFloat(a.booth), isNaN(parseFloat(b.booth))? 0:parseFloat(b.booth), isAsc);
        default: return 0;
      }
    });
    this.limitFile();
  }

  sortFile() {
    if (!this.sortedu.active || this.sortedu.direction === '') {
      return;
    }
    this.sortedfilelist = this.sortedfilelist.sort((a, b) => {
      const isAsc = this.sortedu.direction === 'asc';
      switch (this.sortedu.active) {
        case 'title': return this.compare(a.introFormGroup.ProjectTitle, b.introFormGroup.ProjectTitle, isAsc);
        case 'name': return this.compare(a.introFormGroup.Applicant, b.introFormGroup.Applicant, isAsc);
        case 'description': return this.compare(a.introFormGroup.School, b.introFormGroup.School, isAsc);
        case 'result': return this.compare(a.result, b.result, isAsc);
        case 'booth': return this.compare(isNaN(parseFloat(a.booth))? 0:parseFloat(a.booth), isNaN(parseFloat(b.booth))? 0:parseFloat(b.booth), isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  compareDate(a, b, isAsc: boolean) {
    a = new Date(a);
    b = new Date(b);
    return (a > b ? -1 : a < b ? 1 : 0) * (isAsc ? -1 : 1);
  }

  tabChanged(event: MatTabChangeEvent){
    this.selectedIndex = event.index;
    console.log(this.selectedIndex)
    this.filter = this.types[event.index]
    this.sortedfilelist = this.filterAgain();
    this.topPaginator.firstPage();
    this.pageIndex = 0;
    this.offset = this.pageSize * this.pageIndex;
    this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
    this.length = this.filterAgain().length;

  }

  parentTabChanged(event: MatTabChangeEvent){
    this.parentSelectedIndex = event.index;
    this.sortedfilelist = this.filterAgain();
    this.topPaginator.firstPage();
    this.pageIndex = 0;
    this.offset = this.pageSize * this.pageIndex;
    this.sortedfilelist = this.sortedfilelist.slice(this.offset, (this.offset + this.pageSize));
    this.length = this.filterAgain().length;
  }

  dateFormat = new DateFormatService();

  exportExcel() {
    const exportInformation = [];

    this.spinner.show();
    let file = this.filterAgain();

    for (const p of file) {
      const info = {
        "ID": p.id,
        "Invention Title": p.introFormGroup.ProjectTitle || '-',
        "Participant's name": p.introFormGroup.Applicant || '-',
        "Institution": p.introFormGroup.School || '-',
        "Category": p.techFormGroup.Category,
        "Marks": p.averageMark.toFixed(2),
        "Result": p.result || '-',
      }
     
      exportInformation.push(info)
    }
    let naming = (this.parentSelectedIndex === 0? 'Vanguard': 'Traiblazer') + '_GrandAward' 
  
    this.excelHelper.exportAsExcelFile(exportInformation, naming + new Date().getTime());

    this.spinner.hide();

  }

  async downloadA(){
    const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/DUP-A-layout.pdf?alt=media&token=1b30bbd6-2e70-4ce0-ae3e-b24f25f73617'
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    var fileURL = URL.createObjectURL(file);
    var anchor = document.createElement("a");
    anchor.download = "DUP-A-Layout.pdf";
    anchor.href = fileURL;
    anchor.click();
  }

  async downloadB(){
    const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/DUP-B-layout.pdf?alt=media&token=b47b3801-7072-46d5-8a1f-267168b58350'
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    var fileURL = URL.createObjectURL(file);
    var anchor = document.createElement("a");
    anchor.download = "DUP-B-Layout.pdf";
    anchor.href = fileURL;
    anchor.click();
  }

  async downloadC(){
    const url = 'https://firebasestorage.googleapis.com/v0/b/innozilla-1a662.appspot.com/o/DUP-D-layout.pdf?alt=media&token=a8804307-afcd-4235-9610-a73a8924fb55'
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())
    let file = new Blob([existingPdfBytes], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
    var fileURL = URL.createObjectURL(file);
    var anchor = document.createElement("a");
    anchor.download = "DUP-D-Layout.pdf";
    anchor.href = fileURL;
    anchor.click();
  }
 
}
